export const RAW_ALL_APP_SETTINGS_FETCH_SUCCESS = 'RAW_ALL_APP_SETTINGS_FETCH_SUCCESS';
export const RAW_ALL_APP_SETTINGS_FETCH_FAILURE = 'RAW_ALL_APP_SETTINGS_FETCH_FAILURE';
export const RAW_ALL_APP_SETTINGS_FETCH_LOADING = 'RAW_ALL_APP_SETTINGS_FETCH_LOADING';